import { useState, useEffect, useCallback } from "react";
import { HubDashboardData } from "@/modules/hub/features/HubDashboard/api/getHubDashboard/types";
import { getHubDashboard } from "@/modules/hub/features/HubDashboard/api/getHubDashboard/getHubDashboardApi";

export const useHubDashboard = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [dashboardData, setDashboardData] = useState<HubDashboardData | null>(
    null,
  );

  const fetchDashboardData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getHubDashboard();

      setDashboardData(response.data);
    } catch (err) {
      console.error("Error fetching dashboard data:", err);
      setError("An error occurred while loading the dashboard");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDashboardData();
  }, [fetchDashboardData]);

  return {
    news: dashboardData?.news || [],
    featuredResources: dashboardData?.featuredResources || [],
    favorites: dashboardData?.favorites || [],
    sharedWithMe: dashboardData?.sharedWithMe || [],
    loading,
    error,
    refetch: fetchDashboardData,
  };
};
